import { GameVars } from "../../GameVars";

    export class TeamCursor extends Phaser.Group {

        public teamID: number;
        private cursorImage: Phaser.Image;
        private tournamentData: TournamentData;
        private cursorImageScale: number;
        private py: number;
        private playButton: Phaser.Image;

        constructor(game: Phaser.Game, tournamentData: TournamentData, py: number) {

            super(game, null, "team_button", false);

            this.tournamentData = tournamentData;

            this.scale.y = GameVars.scaleY;

            this.x = 535;
            this.y = py;
            this.py = py;

            this.teamID = GameVars.getTeamIDFromTeamName(this.tournamentData.selectedTeamName);

            const cursorImageName = "seleccion_" + GameVars.formatNumberForTextureAtlas(this.teamID);
            this.cursorImageScale = 1.15;

            this.cursorImage = new Phaser.Image(this.game, 0, 0, "texture_atlas_5", cursorImageName);
            this.cursorImage.anchor.setTo(.5);
            this.cursorImage.x += this.cursorImage.width / 2;
            this.cursorImage.y += this.cursorImage.height / 2;
            this.cursorImage.scale.setTo(this.cursorImageScale , this.cursorImageScale);
            this.add(this.cursorImage);

            if (!this.tournamentData.won) {

                this.playButton = new Phaser.Image (this.game, 162, 55, "texture_atlas_5", "play_level_off");
                this.playButton.anchor.setTo(.5);
                this.add ( this.playButton );

                const pulseTween = this.game.add.tween(this.playButton.scale);
                pulseTween.to ({x: 1.05, y: .95}, 300,  Phaser.Easing.Linear.None, false);
                pulseTween.delay (50);
                pulseTween.to ({x: .95, y: 1.05}, 700,  Phaser.Easing.Elastic.Out);
                pulseTween.loop();
                pulseTween.start();
            }

            if (this.tournamentData.won && GameVars.tournamentJustUnlocked) {

                this.jumpToTrophy();

            } else if (this.tournamentData.won ) {

                this.x -= 140;
                this.y -= 90;

            } else if (this.tournamentData.name === GameVars.currentTournamentName && GameVars.matchJustUnlocked) {

                this.jump();
            }
        }

        public onTeamSelected(teamID: number) {

            this.teamID = teamID;
            this.cursorImage.frameName =  "seleccion_" + GameVars.formatNumberForTextureAtlas(this.teamID);
        }

        private jump(): void {

            this.y = this.py + 90;
            this.game.add.tween(this)
                .to({y: this.py}, 750,  Phaser.Easing.Cubic.Out, true, 1200);
        }

        private jumpToTrophy(): void {

            const trophy_px = this.x - 140;
            const trophy_py = this.y - 90;

            this.game.add.tween(this)
                .to({x: trophy_px, y: trophy_py}, 750, Phaser.Easing.Cubic.Out, true, 1200);
        }
    }
